import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../ui/Logo';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white pt-20 pb-10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-16">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/">
              <Logo light iconOnly={false} />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering the next generation in Guinea-Bissau through faith-based initiatives, nutrition, and quality education since 1998.
            </p>
            {/* Social media icons removed as requested */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-8 text-secondary uppercase tracking-widest">Navigation</h4>
            <ul className="space-y-4 text-sm font-medium text-gray-400">
              <li><Link to="/about" className="hover:text-white transition-colors">Our Story</Link></li>
              <li><Link to="/programs" className="hover:text-white transition-colors">Mission Programs</Link></li>
              <li><Link to="/impact" className="hover:text-white transition-colors">Impact Reports</Link></li>
              <li><Link to="/gallery" className="hover:text-white transition-colors">Photo Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Get in Touch</Link></li>
            </ul>
          </div>

          {/* Involvement */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-8 text-secondary uppercase tracking-widest">Support</h4>
            <ul className="space-y-4 text-sm font-medium text-gray-400">
              <li><Link to="/get-involved" className="hover:text-white transition-colors">Direct Giving</Link></li>
              <li><Link to="/get-involved" className="hover:text-white transition-colors">Child Sponsorship</Link></li>
              <li><Link to="/get-involved" className="hover:text-white transition-colors">Corporate Partners</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Volunteer Opportunities</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-8 text-secondary uppercase tracking-widest">Contact</h4>
            <ul className="space-y-5 text-sm text-gray-400">
              <li className="flex items-start gap-4">
                <SafeIcon icon={FiIcons.FiMail} className="text-secondary text-lg" />
                <span>Agir.usa.2025@gmail.com</span>
              </li>
              <li className="flex items-start gap-4">
                <SafeIcon icon={FiIcons.FiMapPin} className="text-secondary text-lg" />
                <span>Guinea-Bissau Operations Center<br />Serving 1,000+ Children Daily</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-[11px] uppercase tracking-[0.2em] font-bold text-gray-500">
          <p>© {new Date().getFullYear()} AGIR USA. 501(C)(3) NONPROFIT ORGANIZATION.</p>
          <div className="flex gap-8">
            <Link to="/" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/" className="hover:text-white transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;